type VersionInfo = {
  hash: string;
  timestamp: string;
};

const VERSION_STORAGE_KEY = 'app_version_hash';
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

let isInitialized = false;
let currentVersion: string | null = null;

const getVersionUrl = (): string => {
  const base = process.env.PUBLIC_URL || '';
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${normalizedBase}/assets/version.json?t=${Date.now()}`;
};

const isValidVersionInfo = (value: unknown): value is VersionInfo => {
  if (typeof value !== 'object' || value === null) return false;

  const candidate = value as Partial<VersionInfo>;
  return typeof candidate.hash === 'string' && typeof candidate.timestamp === 'string';
};

const applyUpdate = (newHash: string): void => {
  localStorage.setItem(VERSION_STORAGE_KEY, newHash);
  setTimeout(() => {
    window.location.reload();
  }, 100);
};

const checkForUpdates = async (): Promise<void> => {
  try {
    const response = await fetch(getVersionUrl(), {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (!response.ok) return;

    const payload: unknown = await response.json();
    if (!isValidVersionInfo(payload)) return;

    const serverHash = payload.hash;
    const storedHash = localStorage.getItem(VERSION_STORAGE_KEY);

    if (currentVersion === null) {
      currentVersion = serverHash;

      if (storedHash && storedHash !== serverHash) {
        applyUpdate(serverHash);
      } else {
        localStorage.setItem(VERSION_STORAGE_KEY, serverHash);
      }
      return;
    }

    if (serverHash !== currentVersion) {
      console.log(`[UpdateService] Nouveau déploiement détecté : ${serverHash}`);
      currentVersion = serverHash;
      applyUpdate(serverHash);
    }
  } catch (error) {
    // Ignore transient network/parse errors and retry on next cycle.
  }
};

export const initUpdateService = (): void => {
  if (isInitialized || process.env.NODE_ENV === 'test') return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  isInitialized = true;

  void checkForUpdates();

  setInterval(() => {
    console.log(`[UpdateService] Vérification des mises à jour...`);
    void checkForUpdates();
  }, CHECK_INTERVAL_MS);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void checkForUpdates();
    }
  });

  window.addEventListener('focus', () => {
    if (document.visibilityState === 'visible') {
      void checkForUpdates();
    }
  });
};
